import { EmptyTips } from '@/components/EmptyTips';
import { tableHeaderBg } from '@/styles/variants';
import { Table as ArcoTable, Card, TableProps } from '@arco-design/web-react';
import { SorterInfo } from '@arco-design/web-react/es/Table/interface';
import { useEffect, useState } from 'react';
import styled from 'styled-components';

export { EmptyTips };

export const StyledTable = styled(ArcoTable)`
  .arco-table-container .arco-table-th {
    border-radius: 0;
    background-color: ${tableHeaderBg};
    white-space: nowrap;
  }
  .arco-table-cell {
    color: #000;
    opacity: 0.85;
  }
  .arco-table-td {
    line-height: 1.5;
    white-space: nowrap;
    padding: 9px 16px;
  }
  table {
    width: auto !important;
  }
  .arco-table table thead tr:first-child th:first-child {
    left: 0px !important;
  }
`;

export const defaultPagenation = {
  current: 1,
  pageSize: 10,
  total: 0,
  showTotal: true,
  showJumper: true,
  sizeCanChange: true,
  defaultCurrent: 1,
};

export function Table({
  pagination,
  handlePagination,
  prefix,
  ...res
}: TableProps & {
  handlePagination?: ({ page, limit }, { sorter, filters, extra }) => void;
  pagination?: { page: number; limit: number; total: number } | boolean;
  prefix?: React.ReactNode;
}) {
  const [pageConfig, setPageConfig] = useState(defaultPagenation);
  const [showPagination, setShowPagination] = useState(true);

  useEffect(() => {
    if (typeof pagination === 'boolean') {
      setShowPagination(pagination);
    } else {
      setPageConfig((pre) => ({
        ...pre,
        ...(pagination as any),
        pageSize: pagination?.limit,
        total: pagination?.total,
        current: pagination?.page,
      }));
    }
  }, [pagination]);

  const onChange = (
    { current, pageSize },
    sorter: SorterInfo | SorterInfo[],
    filters: any,
    extra: { currentData: any[]; currentAllData: any[]; action: 'paginate' | 'sort' | 'filter' },
  ) => {
    handlePagination({ limit: pageSize, page: current }, { sorter, filters, extra });
  };

  return (
    <Card bordered={false}>
      {prefix}
      <StyledTable
        onChange={onChange}
        {...res}
        border={false}
        pagination={showPagination ? pageConfig : false}
        scroll={{ x: 'max-content' }}
        noDataElement={<EmptyTips />}
      />
    </Card>
  );
}
